<template>
  <div class="cadastro-usuario">
    <v-container fluid>
      <h1 class="titulo">Comissões</h1>
      <v-row>
        <v-col cols="12" class="py-0">
          <ExpansionPanelDefault :handleClick="montarLabelFiltro">
          <v-row class="justify-normal">
            <v-col cols="12" md="2">
              <v-select
                v-model="tipoStatus"
                :items="tiposStatus"
                label="Selecionar estado"
                dense
                hide-details
                solo
                class="select-status"
              >
              </v-select>
            </v-col>

            <v-col cols="12" md="3">
              <DateModal 
                :dates.sync="data"
                :maxDateRange="30"
                
              />
            </v-col>
            <v-col cols="12" md="2">
              <v-btn
                :color="variables.colorPrimary"
                @click.prevent="buscar()"
                class="br-btn"
                :loading="loading">Processar</v-btn>

            </v-col>
          </v-row>
        </ExpansionPanelDefault>
        </v-col>

      </v-row>

      <div class="box-table box-table-gecom">
        <v-skeleton-loader
          :loading="loadingTable"
          :transition="'fade-transition'"
          height="500"
          type="table">
          <v-data-table
            class="mt-4"
            :headers="headers"
            :search="search"
            :items="listaItens"
            width="300px"
            flat
            :expanded.sync="expanded"
            @click:row="expandRow"
            show-expand
            single-expand
            hide-default-footer
            :loading="loadingPag"
            :show-select="false"
            :items-per-page.sync="itemsPerPage"
            item-key='idContractSettlements'
          >

            <template v-slot:item.payIntervalType="{ item }">
              {{ typesInterval[item.payIntervalType]  }}
            </template>

            <template v-slot:item.status="{ item }">
              <!-- <div :style="`color: ${defineCorStatus(item.status)}`"> {{ tiposStatus.find(it => it.value === item.status).text   }} </div> -->
              <v-chip class="chips-status" :color="`${defineCorStatus(item.status)}`"> {{ tiposStatus.find(it => it.value === item.status).text   }} </v-chip>
            </template>

            <template v-slot:item.comissionValue="{ item }">
              {{ item.comissionValue | currency }}
            </template>

            <template v-slot:item.contractName="{ item }">
              {{ formatContractName(item) }}
            </template>

            <template v-slot:item.periodStart="{ item }">
              {{ item.periodStart }}
            </template>

            <template v-slot:item.periodEnd="{ item }">
              {{ item.periodEnd }}
            </template>

            <template v-slot:item.data-table-expand="{ item, expand, isExpanded }">
              <div v-if="item.contractName === 'Comissão por Referência'">
                <span style="font-size: 24px" v-if="expand && !isExpanded" class="mdi mdi-chevron-down"></span>
                <span style="font-size: 24px" v-if="isExpanded" class="mdi mdi-chevron-up"></span>
              </div>
            </template>

            <template v-slot:expanded-item="{ headers, item }">
             <td :colspan="headers.length" class="pr-0">
              <v-data-table 
                class="fb-table-elem pl-0 pr-0"
                :headers="expandHeaders"
                :items="[item.contractSettlementRef]"
                item-key="k"
                hide-default-footer
                :disable-pagination="true"
              >

              <template v-slot:item.payIntervalType="{ item }">
                {{ typesInterval[item.payIntervalType]  }}
              </template>

              <template v-slot:item.status="{ item }">
                <!-- <div :style="`color: ${defineCorStatus(item.status)}`"> {{ tiposStatus.find(it => it.value === item.status).text   }} </div> -->
                <v-chip class="chips-status" :color="`${defineCorStatus(item.status)}`"> {{ tiposStatus.find(it => it.value === item.status).text   }} </v-chip>
              </template>

              <template v-slot:item.comissionValue="{ item }">
                {{ item.comissionValue | currency }}
              </template>

              <template v-slot:item.contractName="{ item }">
                {{ formatContractName(item) }}
              </template>

              <template v-slot:item.periodStart="{ item }">
                {{ item.periodStart }}
              </template>

              <template v-slot:item.periodEnd="{ item }">
                {{ item.periodEnd }}
              </template>

              </v-data-table>
             </td>
            </template>
          
            <template v-slot:footer>
              <div class="wrapper-footer">
                <div class="qtd-paginacao">
                  {{ pageStart }}
                  -
                  {{ pageStop }}
                  de
                  {{ totalItens }}
                </div>
                <v-pagination
                  v-model="page"
                  :length="numberOfPages"
                  circle
                  :disabled="disabled"
                  :total-visible="7"
                  class="box-table-paginacao"
                  v-if="numberOfPages > 1"></v-pagination>
              </div>
            </template>
          </v-data-table>
        </v-skeleton-loader>
      </div>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { errorSnackbar } from '@/core/service/utils'
import moment from 'moment'
import Events from '@/core/service/events'

/**
 * MIXIN
 */
import listagemTables from '@/views/mixins/listagemTables'

const namespaceStore = 'afiliadosComissao'

export default {
  name: 'afiliadosComissaoPage',
  components: {
    // rangeDate: () => import('../../components/rangeDateParceiros'),
    DateModal: () => import('./components/dateModal'),
    ExpansionPanelDefault: () => import('@/views/components/expansionPanelDefault'),
  },
  mixins: [listagemTables],
  data: () => ({
    loading: false,
    loadingFechandoLiquidacoes: false,
    loadingFechamento: false,
    loadingTable: false,
    data: [moment().add(-7, 'd').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
    textSearch: '',
    selected: [],
    expanded: [],
    headers: [
      { align: 'start', class: 'table-header', text: 'ID', value: 'idContractSettlements' },
      { align: 'start', class: 'table-header', text: 'Nome', value: 'fullName' },
      { align: 'start', class: 'table-header', text: 'Comissão', value: 'comissionValue' },
      { align: 'start', class: 'table-header', text: 'Tipo de Comissão', value: 'contractName' },
      { align: 'start', class: 'table-header', text: 'Data Criação', value: 'created' },
      { align: 'start', class: 'table-header', text: 'Data Atualização', value: 'updated' },
      { align: 'start', class: 'table-header', text: 'Data Inicio', value: 'periodStart' },
      { align: 'start', class: 'table-header', text: 'Data Final', value: 'periodEnd' },
      { align: 'center', class: 'table-header', text: 'Status', value: 'status' },
      { sortable: false, align: 'left', text: '', value: 'data-table-expand' },
    ],
    expandHeaders: [
      { align: 'start', class: 'table-header', text: 'ID', value: 'idContractSettlements' },
      { align: 'start', class: 'table-header', text: 'Nome', value: 'fullName' },
      { align: 'start', class: 'table-header', text: 'Comissão', value: 'comissionValue' },
      { align: 'start', class: 'table-header', text: 'Tipo de Comissão', value: 'contractName' },
      { align: 'start', class: 'table-header', text: 'Data Criação', value: 'created' },
      { align: 'start', class: 'table-header', text: 'Data Atualização', value: 'updated' },
      { align: 'start', class: 'table-header', text: 'Data Inicio', value: 'periodStart' },
      { align: 'start', class: 'table-header', text: 'Data Final', value: 'periodEnd' },
      { align: 'center', class: 'table-header', text: 'Status', value: 'status' },
      { sortable: false, align: 'left', text: '', value: 'action' },
    ],
    tiposStatus: [
      { text: 'Todos', value: 'N,P,F,R' },
      { text: 'Novo', value: 'N' },
      { text: 'Pago', value: 'P' },
      { text: 'Fechado', value: 'F' },
      { text: 'Rejeitado', value: 'R' },
    ],
    tipoStatus: 'Todos',
    isOpenModal: false,
    dataContractSettlements: undefined
  }),

  watch: {
    tipoStatus (v, old) {
      if (v !== old) {
        this.page = 1
      }
      this.buscar()
    }
  },

  mounted () {
    this.buscar()
    this.init()
  },

  computed: {
    ...mapGetters(namespaceStore, ['listaItens', 'totalItens']),
    ...mapGetters('auth', ['user']),
    typesInterval ()  {
      return {
        'DAY': 'Dias'
      }
    },
    statusSelecionado () {
      if(this.tipoStatus.length > 1) {
        return this.tiposStatus.filter(status => status.text !== 'Todos').map(status => status.text)
      }else {
        const selectedStatus = this.tiposStatus.find(status => status.value === this.tipoStatus);
        return selectedStatus ? [selectedStatus.text] : []
      }
    }
  },

  methods: {
    ...mapActions(namespaceStore, ['getItens', 'limparTabela', 'fecharLiquidacoes']),

    clearDados () {
      // this.clearItens()
    },

    init (){},

    getData () {
      this.limparTabela()
      if(this.tipoStatus === 'Todos') {
        this.tipoStatus = this.tiposStatus.filter(status => status.text !== 'Todos')
        .map(status => status.value)
      }
      this.loadingTable = true
      this.getItens({ 
        page: this.page,
        status: this.tipoStatus,
        dtStart: this.data[0], 
        dtEnd: this.data[1],
        pageSize: this.$store.getters.ItensPaginacao,
      })
      .catch(err => {
        errorSnackbar(err)
      })
      .finally(() => this.loadingTable = false)
    },

    closeModal (v) {
      if (v) {
        this.getData()
      }

      this.isOpenModal = false
      this.dataContractSettlements = undefined
    },

    buscar () {
      this.getData()
    },

    paginacao() {
      this.getData()
    },
    abrirModalRejetar (e) {
      this.isOpenModal = true
      this.dataContractSettlements = e
    },

    limparDados () {
      this.selected = []
      this.limparTabela()
    },

    montarLabelFiltro(){
      Events.$on('autoCompleteEntities::getSearchText', (val)=>{ this.terminalTextSelected = val })
      let labelFiltro = [
      {
          label: 'Data Inicial:',
          value: moment(this.data[0]).format('DD/MM/YYYY')
        },
        {
          label: 'Data Final:',
          value: moment(this.data[1]).format('DD/MM/YYYY')
        },
        {
          label: 'Status:',
          value: this.statusSelecionado
        },
    ]
      return labelFiltro
    },
    defineCorStatus(valueStatus) {
      if (valueStatus === 'N') return 'blue'
      if (valueStatus === 'P') return this.variables.colorSuccess
      if (valueStatus === 'F') return 'orange'
      if (valueStatus === 'R') return '#b73228'
      else return ''
    },
    formatDate(item) {
      if(!item) return 'Nenhuma Data Informada!'
      return moment(item).format('DD/MM/YYYY')
    },
    formatContractName(item) {
      `${item.contractName}  -  (${item.affiliateContractTypeId})`
      if(item.contractName === 'Comissão por Referência'){
        return `${item.contractName}`
      }else {
        return `${item.contractName}  -  (${item.affiliateContractTypeId})`
      }
    },
    expandRow(value) {
      if(value.contractName === 'Comissão por Referência') {
        this.expanded = value === this.expanded[0] ? [] : [value]
      }
    },
  },
}
</script>

<style lang="scss">
  @import '~@/assets/styles/components/table';
  .v-data-table thead tr th,
  .v-data-table .v-data-table-header th.sortable .v-data-table-header__icon {
    color: $colorPrimary !important;
  }

  .chips-status {
    min-width: 100px !important;
    justify-content: center;
    font-weight: 500;
    span{
      color: black;
    }
  }

  .box-table {

    .v-data-table-header-mobile {
      display: none;
    }

    &.box-table-gecom {
      .v-data-table > .v-data-table__wrapper > table > tbody > tr > th {
        height: auto;
        padding: 5px;
        font-size: 11px;
      }
    }
  }

  .fab-cadastrar-usuario {
    position: fixed;
    z-index: 1;
    bottom: 25px;
    right: 5px;

    @media (min-width: 599px) {
      display: none !important;
    }
  }

  .btn-fechar-liquidacao.theme--dark.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
    background-color: #b5b5b5 !important;
    color: #262626 !important;
  }

  .box-total {
    padding: 10px !important;
    background-color: #f07d0a !important;
  }
</style>
